// ResizeObserver loop 경고 무시 (Ant Design 내부 이슈, 기능 무관)
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) e.stopImmediatePropagation();
});

import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import CssLoader from './css-loader';
import apiInstance from './axios';
import axios from 'axios';

import Antd from 'ant-design-vue';
import VueDatePicker from '@vuepic/vue-datepicker';

import 'ant-design-vue/dist/reset.css';
import '@vuepic/vue-datepicker/dist/main.css';
// sweetalert2 v11은 CSS 자동 주입을 하지 않으므로 전역에서 명시적으로 로드 (미포함 시 전체 앱 팝업 무스타일)
import 'sweetalert2/dist/sweetalert2.min.css';
import { BuildModeEnum } from './enums/common.enums';

import { createI18n } from 'vue-i18n'                       // vue-i18n import
import messages from './i18n'                               // message import

import { convertProfile } from './utils/utils';
import { waitForStudioSession, acknowledgeStudioSession, onStudioSessionEnd, endStudioSession, isStudioEmbed, getStudioAccessToken } from './utils/studioEmbed';

const app = createApp(App);

// Hotjar
import Hotjar from '@hotjar/browser';
const siteId =  process.env.VUE_APP_HOTJARID;
const hotjarVersion = 6;
if(process.env.NODE_ENV !== BuildModeEnum.DEV && process.env.NODE_ENV !== BuildModeEnum.LOCAL) 
    Hotjar.init(siteId, hotjarVersion);

const i18n = createI18n({
    locale: 'ko',
    fallbackLocale: 'ko',
    warnHtmlInMessage: 'off',
    messages,
})

if(process.env.NODE_ENV !== 'local') {
    app.config.errorHandler = async function(err, vm, info) {
        const errorData = {
            type: 'HOSPITAL',
            environment: convertProfile(),
            error: err.toString(),
            stack: err.stack,
            info: info,
            // 주소의 쿼리·조각(옛 토큰 쿼리·#c= 1회용 코드)이 실리지 않게 경로만(설계 1-11)
            url: window.location.pathname,
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            payload: {},
            // 화면 데이터(props)는 개인정보가 섞일 수 있어 보내지 않음, 라우트도 경로만
            route: vm && vm.$route ? vm.$route.path : 'no route',
            userMessage: vm && vm.$data && vm.$data.userMessage ? vm.$data.userMessage : 'no user message',
        };
        if(err.payload) errorData.payload = err.payload;
        if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') return;
        
        // maskingByLetter 로직은 그대로 두고 해당 오류가 났을 때 메시지 안보내는걸로 처리
        const isSigninPage = err.route = '/signin';
        const isRepeatError = err && err.message && err.message.includes('Invalid count value: -1');
        if (isSigninPage && isRepeatError) {
            return;
        }
        postErrorToBackend(errorData);
    }
}

const postErrorToBackend = async (parameter) => {
    try {
        await axios.post(`${process.env.VUE_APP_SERVERURL}/monitoring/vue/error`, parameter);
    } catch(error) {
        console.log('could not send', error);
    }
}

app.config.globalProperties.$apiInstance = apiInstance;
let appMounted = false;
function showStudioError(error) {
    if (appMounted) {
        app.unmount();
        appMounted = false;
    }
    const root = document.getElementById('app');
    if (root) {
        root.textContent = error.message || 'Studio에서 인증서 메뉴를 다시 열어주세요.';
        root.setAttribute('role', 'alert');
    }
}
onStudioSessionEnd(showStudioError);

async function startApp() {
    try {
        // app.use(router) starts navigation/API calls, so it must also wait for INIT.
        await waitForStudioSession();
        app.component('VueDatePicker', VueDatePicker);
        app.use(store);
        app.use(i18n);
        app.use(CssLoader);
        app.use(Antd);
        app.use(router);
        await router.isReady();
        if (isStudioEmbed()) getStudioAccessToken();
        app.mount('#app');
        appMounted = true;
        acknowledgeStudioSession();
    } catch (error) {
        if (isStudioEmbed()) {
            endStudioSession(error);
            showStudioError(error);
        } else {
            throw error;
        }
    }
}
startApp();
  


export { i18n };
